import styled from 'styled-components';

export const MarkdownWrapper = styled.div`
    flex: 1;
    overflow: auto;

    .wmde-markdown {
        font-size: 14px;
    }
`;
